export const THEORY_BOOKING_LESSONS = 'THEORY_BOOKING_LESSONS';
export const THEORY_BOOKING_APPLICANTS = 'THEORY_BOOKING_APPLICANTS';
export const DRIVING_BOOKING_APPLICANTS = 'DRIVING_BOOKING_APPLICANTS';
export const LESSON_STATUS = 'LESSON_STATUS';
export const LESSONS_EDIT = 'LESSONS_EDIT';


// WEBPACK FOOTER //
// ./src/containers/search/SearchType.js